export type PassportSection =
  | 'overview'
  | 'assets'
  | 'data'
  | 'compliance'
  | 'controls'
  | 'evidence'
  | 'remediation'
  | 'readiness'
  | 'graph'

export const PASSPORT_DETAIL_SECTIONS: PassportSection[] = [
  'overview',
  'assets',
  'data',
  'compliance',
  'controls',
  'evidence',
  'remediation',
  'readiness',
]

export function passportSectionElementId(section: PassportSection): string {
  switch (section) {
    case 'overview':
      return 'passport-section-overview'
    case 'assets':
      return 'passport-section-assets'
    case 'data':
      return 'passport-section-data'
    case 'compliance':
      return 'passport-section-compliance'
    case 'controls':
      return 'passport-section-controls'
    case 'evidence':
      return 'passport-section-evidence'
    case 'remediation':
      return 'passport-section-remediation'
    case 'readiness':
      return 'passport-section-readiness'
    case 'graph':
      return 'passport-section-graph'
    default:
      return 'passport-section-overview'
  }
}
